import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/movimentacao/compra' };
/////////////////////////////////////////////////////////////////////////////////

export function createCompraAnimal(payload) {
  return httpService.post(args, payload);
}

export function updateCompraAnimal(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listCompraAnimal(param) {
  return httpService.get({ ...args, args: param });
}

export function findCompraAnimal(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllCompraAnimal() {
  return httpService.get({ ...args, path: '/pecuaria/movimentacao/compra/all' });
}

export function deleteCompraAnimal(id) {
  return httpService.del({ ...args, args: `/${id}` });
}